import { api } from './client'

/** Loại máy trạm — để cảnh báo nói rõ máy nào im chứ không chỉ "có một máy". */
export type StationKind = 'order' | 'production' | 'warehouse'

export interface StationReadinessPayload {
    session_id: string
    sse_connected: boolean
    sound_enabled: boolean
    audio_blocked: boolean
    /** Bỏ trống = máy trạm đơn hàng (giữ tương thích bản cũ đang chạy). */
    kind?: StationKind
}

export const stationReadinessApi = {
    report: (payload: StationReadinessPayload, signal?: AbortSignal) =>
        api.post<void>('/station/readiness', payload, { signal }),
}
